import styled from "styled-components";
import SearchWeather from "./components/SearchWeather";

import React, { useState } from "react";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  margin: 20px;
  padding: 20px;
  width: 260px;
  box-shadow: 0px 3px 6px 0px black;
  background: linear-gradient(pink, white);
`;

const HeadingTextLabel = styled.div`
  font-size: 25px;
  text-align: center;
  font-weight: bold;
  color: rgb(148, 77, 130);
`;

function App() {
  return (
    <Container>
      <HeadingTextLabel>Weather App</HeadingTextLabel>

      <SearchWeather />
    </Container>
  );
}

export default App;
